import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { Input } from 'reactstrap';

export const ModalSendEmail = ({
    respuestaAPI,
    onBack,
    sending,
    sendConfig,
    onSend,
    letter,
    handleInputChange
}) => {


  
    const [sendPatientEmail, setSendPatientEmail] = useState(false);
    const [sendPatientWhats, setSendPatientWhats] = useState(false);
    const [sendDoctorEmail, setSendDoctorEmail] = useState(false);
    const [sendDoctorWhats, setSendDoctorWhats] = useState(false);
    const [printResult, setPrintResult] = useState(sendConfig?.print_results ?? false);
    const [selectAllSend, setSelectAllSend] = useState(false);

    const handleSend = () => {
        onSend({
            sendPatient: sendPatientEmail,
            sendDoctor: sendDoctorEmail,
            printResult: printResult
        });
    };

    
    const hasSendOptions =
        sendConfig?.send_email ||
        sendConfig?.send_whatsapp ||
        sendConfig?.send_doctor ||
        sendConfig?.send_whatsapp_doctor;

    const totalSelected = [sendPatientEmail, sendDoctorEmail,sendPatientWhats, sendDoctorWhats, printResult ].filter(Boolean).length;
    let enable_whatsapp = localStorage.getItem('enable_whatsapp');

   const handleSelectAllSend = () => {

        const newState = !selectAllSend;
        setSelectAllSend(newState);

        const enableWhatsapp = localStorage.getItem('enable_whatsapp') === "True";

        if (newState) {

            if (sendConfig?.send_email)
                setSendPatientEmail(true);

            if (sendConfig?.send_whatsapp && enableWhatsapp)
                setSendPatientWhats(true);

            if (sendConfig?.send_doctor)
                setSendDoctorEmail(true);

            if (sendConfig?.send_whatsapp_doctor && enableWhatsapp)
                setSendDoctorWhats(true);

        } else {

            setSendPatientEmail(false);
            setSendPatientWhats(false);
            setSendDoctorEmail(false);
            setSendDoctorWhats(false);
        }
    };

    return (
        <div className="send-wrapper">

            <div className="send-header-modern">
                <h4>¿Cómo deseas gestionar los resultados?</h4>
                <p>Selecciona las opciones de envío digital y/o impresión física que requieras.</p>
            </div>



            <div className="send-cards-row">
                <div className="section-divider">
                <span>IMPRESIÓN</span>
            </div>


                <div className={` print-row ${printResult ? "selected" : ""}`} >
                    

                    <div className="print-left">
                        <div className="print-icon">
                            <i className="icofont icofont-printer"></i>
                        </div>
                
                        <div className="print-title">
                            IMPRESIÓN
                        </div>
                    </div>

                    <div className="print-actions">

                        <button
                            className={`print-check ${printResult ? "active" : ""}`}
                            // disabled={!sendConfig?.printResult}
                            onClick={() => setPrintResult(!printResult)}
                        >
                            <i className="fa fa-check"></i>
                        </button>

                        <div className="print-divider"></div>

                        <div className={`membrete-wrapper ${!printResult ? "disabled" : ""}`}>
                            <div className="doc-icon">
                                <i className="fa fa-file-text-o"></i>
                            </div>
                            <span className="membrete-label">¿MEMBRETE?</span>

                            <label className="switch">
                                <Input
                                    type="checkbox"
                                    name="letter"
                                    onChange={handleInputChange}
                                    checked={letter}
                                    disabled={!printResult}
                                />
                                <span className="slider"></span>
                            </label>

                          

                        </div>

                    </div>

                </div>
                {hasSendOptions && (
                <>

                    <div className="section-divider">
                        <span>ENVÍOS</span>
                    </div>
                    <div className="send-row-group">

                    <div className={`send-row send-row-small ${selectAllSend ? "selected" : ""}`}>
                        <button
                            className={`action-btn ${selectAllSend ? "active" : ""}`}
                            onClick={handleSelectAllSend}
                        >
                            <i className="fa fa-check"></i>
                        </button>
                    </div>

                   <div className={`send-row ${sendPatientEmail || sendPatientWhats ? "selected" : ""}`}>

                        <div className="send-user-info">
                            <div className="send-user-icon">
                                <i className="fa fa-user"></i>
                            </div>

                            <div>
                                <div className="send-user-title">PACIENTE</div>
                                <div className="send-user-name">
                                    {respuestaAPI?.patient_name}
                                </div>
                            </div>
                        </div>

                        <div className="send-actions">
                            <button
                                className={`action-btn email ${sendPatientEmail ? "active" : ""}`}
                                disabled={!sendConfig?.send_email}
                                onClick={() => setSendPatientEmail(!sendPatientEmail)}
                            >
                                <i className="fa fa-envelope"></i>
                            </button>

                            
                            {enable_whatsapp === "True" && (
                                <button
                                    className={`action-btn whatsapp ${sendPatientWhats ? "active" : ""}`}
                                    disabled={!sendConfig?.send_whatsapp}
                                    onClick={() => setSendPatientWhats(!sendPatientWhats)}
                                >
                                    <i className="fa fa-whatsapp"></i>
                                </button>
                            )}
                        </div>

                    </div>

                    <div className={`send-row ${sendDoctorEmail || sendDoctorWhats ? "selected" : ""}`}>
                        <div className="send-user-info mr-2">
                            <div className="send-user-icon doctor">
                                <i className="fa fa-user-md"></i>
                            </div>

                            <div>
                                <div className="send-user-title">MÉDICO</div>
                                <div className="send-user-name">
                                    {respuestaAPI?.doctor_name}
                                </div>
                            </div>
                        </div>
                        <div className="send-actions">
                            <button
                                className={`action-btn email ${sendDoctorEmail ? "active" : ""}`}
                                disabled={!sendConfig?.send_doctor}
                                onClick={() => setSendDoctorEmail(!sendDoctorEmail)}
                            >
                                <i className="fa fa-envelope"></i>
                            </button>
                            {enable_whatsapp === "True" && (
                                <button
                                    className={`action-btn whatsapp ${sendDoctorWhats ? "active" : ""}`}
                                    disabled={!sendConfig?.send_whatsapp_doctor}
                                    onClick={() => setSendDoctorWhats(!sendDoctorWhats)}
                                >
                                    <i className="fa fa-whatsapp"></i>
                                </button>
                            )}
                        </div>

                    </div>

                </div>
                   
                </>
                
                )}
            </div>
        
            <div className="send-footer-modern">
                <button className="back-btn-send" onClick={onBack}><i className='fa fa-arrow-left'></i></button>
                <Button
                    className="send-btn-modern"
                    disabled={totalSelected === 0 || sending}
                    onClick={handleSend}
                >
                    {sending ? (
                        <>
                            <i className="fa fa-spinner fa-spin mr-2"></i>
                            Enviando...
                        </>
                    ) : (
                        <>
                            ENVIAR A {totalSelected} DESTINO{totalSelected !== 1 && "S"}{" "}
                            <i className='fa fa-paper-plane'></i>
                        </>
                    )}
                </Button>
            </div>

        </div>
    );
};